import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const TargetSection = () => {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation();
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation();

  return (
    <section id="ma-cible" className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">
              Ma cible
            </span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">
            Vous êtes au <em className="text-brand-fuchsia">bon endroit</em>
          </h2>
          <p className="text-brand-gray max-w-xl mx-auto text-base leading-relaxed">
            Nos services sont conçus pour répondre aux besoins spécifiques des entreprises et des particuliers en quête de qualité et d'élégance.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* Entreprises */}
          <div
            ref={leftRef}
            className={`bg-brand-beige rounded-2xl p-8 transition-all duration-700 ${leftVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 shrink-0 rounded-full bg-brand-fuchsia/10 flex items-center justify-center">
                <i className="ri-building-2-line text-brand-fuchsia text-2xl" />
              </div>
              <div>
                <h3 className="font-serif text-xl font-semibold text-brand-anthracite">
                  Les entreprises
                </h3>
                <p className="text-brand-gray text-sm">Espaces professionnels d'exception</p>
              </div>
            </div>
            <p className="text-brand-gray leading-relaxed mb-6">
              Vous souhaitez créer des espaces innovants et inspirants pour vos collaborateurs ou vos clients — nous concevons des environnements à votre image.
            </p>
            <ul className="space-y-3">
              {[
                'Bureaux et espaces de coworking',
                'Showrooms et espaces commerciaux',
                'Événements corporate et galas',
                'Hôtels et restaurants',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-fuchsia text-sm" />
                  </div>
                  <span className="text-sm text-brand-gray">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Particuliers */}
          <div
            ref={rightRef}
            className={`bg-brand-beige rounded-2xl p-8 transition-all duration-700 ${rightVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 shrink-0 rounded-full bg-brand-coral/10 flex items-center justify-center">
                <i className="ri-user-heart-line text-brand-coral text-2xl" />
              </div>
              <div>
                <h3 className="font-serif text-xl font-semibold text-brand-anthracite">
                  Les particuliers
                </h3>
                <p className="text-brand-gray text-sm">Votre univers intérieur sur mesure</p>
              </div>
            </div>
            <p className="text-brand-gray leading-relaxed mb-6">
              Vous recherchez des prestations haut de gamme, valorisez la qualité et souhaitez être accompagnés avec rigueur et sens du détail.
            </p>
            <ul className="space-y-3">
              {[
                'Aménagement et décoration de résidences',
                'Design de chambres et suites',
                'Décoration événementielle privée',
                'Consultation et conseil en décoration',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-coral text-sm" />
                  </div>
                  <span className="text-sm text-brand-gray">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetSection;